import { useLocation } from "react-router-dom";

interface LandingPageContext {
  lpSlug: string;
  lpSource: string;
  generateTestId: (section: string, action: string) => string;
  generateId: (section: string, action: string) => string;
}

/**
 * Hook para identificar a Landing Page atual e gerar data-testids únicos
 * 
 * @returns {LandingPageContext} Contexto da LP com slug e funções helper
 */
export const useLandingPageContext = (): LandingPageContext => {
  const location = useLocation();
  
  // Mapeamento de rotas para slugs das LPs
  const getLpSlug = (pathname: string): string => {
    switch (pathname) {
      case '/':
        return 'home';
      case '/numerologia-do-nome':
        return 'numerologia';
      case '/mapa-prosperidade':
        return 'prosperidade';
      case '/mapa-vocacoes':
        return 'vocacoes';
      default:
        // Para outras rotas, limpa barras e usa como slug
        return pathname.replace(/^\/+|\/+$/g, '').replace(/\//g, '-') || 'unknown';
    }
  };

  const lpSlug = getLpSlug(location.pathname);
  
  // Gera o data-testid seguindo padrão: lp-[slug]-[section]-[action]
  const generateTestId = (section: string, action: string): string => {
    return `lp-${lpSlug}-${section}-${action}`;
  };

  // Gera o id HTML para tracking GTM (mesmo padrão do testid)
  const generateId = (section: string, action: string): string => {
    return `lp-${lpSlug}-${section}-${action}`;
  };

  // Fonte da LP para tracking GTM
  const lpSource = `landingpage-${lpSlug}`;

  return {
    lpSlug,
    lpSource,
    generateTestId,
    generateId
  };
};